import type { ReactNode } from 'react';
import styles from './CategoryRadio.module.scss';

interface CategoryRadioProps {
  htmlId: string,
  name?: string,
  checked?: boolean,
  onChange?: (checked: boolean) => void,
  label: string | ReactNode,
  image?: string | null,
}

export function CategoryRadio(props: CategoryRadioProps) {
  return (
    <div className={ styles.container } data-checked={ props.checked }>

      { props.image &&
        <div className={ styles.mediaBlock }>
          <div className={ styles.mediaHolder }>
            <img src={ props.image } alt="" />
          </div>
        </div>
      }

      <div className={ styles.contentBlock }>
        <input
          type="radio"
          id={ props.htmlId }
          name={ props.name }
          checked={ props.checked }
          onChange={ (e) => props.onChange ? props.onChange(e.target.checked) : undefined }
          className={ styles.radio }
        />
        <label htmlFor={ props.htmlId } className={ styles.label }>
          <span>{ props.label }</span>
        </label>
      </div>

    </div>
  );
}
